

module.exports = __webpack_require__.stylable.create(
    "feed221671256",
    {"classes":{"root":"feed221671256__root"},"vars":{},"stVars":{"FeedBgColor":"\"fallback(color(--feedBgColor), color(color-1))\""},"keyframes":{}},
    "",
    15,
    "feed221671256",
    null
);
